export default {
  init() {
    if ($('.eventlocation-map-container').length > 0) {
      let geocoder;

      var script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?language=de&region=DE&key=' + sanacorp.gmaps_api_key + '&callback=initMap';
      script.defer = true;
      script.async = true;

      window.initMap = function () {
        geocoder = new google.maps.Geocoder();

        $('.eventlocation-map-container').each(function (index, element) {
          var address = $(element).data('address');
          var map;

          geocoder.geocode({'address': address}, function(results, status) {
            if (status === 'OK') {
              map = new window.google.maps.Map(element, {
                zoom: 14,
                center: results[0].geometry.location,
                disableDefaultUI: true,
              });

              new window.google.maps.Marker({
                position: results[0].geometry.location,
                map: map,
                animation: window.google.maps.Animation.DROP,
                icon: $(element).data('marker'),
              });
            } else {
              console.log('Geocode was not successful for the following reason: ' + status);
            }
          });
        });
      };

     document.head.appendChild(script)
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single.js